import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import CanvasJSReact from "../../../../../assets/canvasjs.react";
import { Tooltip } from "antd";
import InfoIcon from "../../../../../components/utils/icons/info";
import {
  numberMask,
} from "../../../../../services/helpersMethodsService";

const { CanvasJSChart } = CanvasJSReact;

const BarAverageDailyGainChart = (props) => {
  const { translation } = useSelector((state) => state.app);
  const { animalData, animalGMDDashboard } = useSelector(
    (state) => state.animal
  );
  const options = {
    height: 250,
    dataPointWidth: 36,
    axisY: {
      valueFormatString: "0.00",
      includeZero: true,
      gridDashType: "dot",
      maximum:
        animalGMDDashboard != null && animalData != null
          ? Math.max.apply(
              2,
              animalGMDDashboard.map((a) => a.y)
            ) > animalData?.currentWeightGain
            ? Math.round(
                Math.max.apply(
                  2,
                  animalGMDDashboard.map((a) => a.y)
                ) +
                  Math.max.apply(
                    2,
                    animalGMDDashboard.map((a) => a.y)
                  ) *
                    1
              )
            : Math.round(
                animalData?.currentWeightGain +
                  animalData?.currentWeightGain * 1
              )
          : 4,
      minimum:
        animalData != null && animalData?.currentWeightGain < 0
          ? animalData?.currentWeightGain + animalData?.currentWeightGain * 1
          : 0,
      stripLines: [
        {
          value:
            animalData != null && animalData?.currentWeightGain != null
              ? animalData?.currentWeightGain.toFixed(2)
              : 0,
          color: "#4B4B4B",
          thickness: 3,
          labelPlacement: "inside",
          labelFontColor: "#4B4B4B",
          labelAlign: "far",
          showOnTop: true,
          label: `Último: ${
            animalData != null && animalData?.currentWeightGain != null
              ? numberMask(
                  animalData?.currentWeightGain,
                  false
                )
              : 0
          } Kg`,
        },
      ],
    },
    toolTip: {
      enabled: false, //enable here
    },
    data: [
      {
        type: "column",
        yValueFormatString: "0.00",
        indexLabel: "{y}",
        indexLabelFontSize: 12,
        indexLabelPlacement: "inside",
        dataPoints: animalGMDDashboard,
      },
    ],
  };
  return (
    <Fragment>
      <span className="detailTitle">
        {translation.animal.details.averageDailyGain.title}
        <Tooltip title={translation.animal.details.averageDailyGain.tooltip}>
          <InfoIcon />
        </Tooltip>
      </span>
      <div className="chartDiv">
        <CanvasJSChart options={options} />
      </div>
    </Fragment>
  );
};

export default BarAverageDailyGainChart;
